<template>
  <header class="ni-header" id="home">
    <div class="ni-header__inner">
      <!-- Desktop -->
      <div class="ni-header__desktop">
        <a href="#home" class="ni-header__logo-link" @click="handleNavClick('#home', $event)">
          <div class="ni-header__logo">
            <img
              class="ni-header__logo-img"
              src="https://www.qdpic.cn/obs/images/195e37770fe5a66e8c08e916b144cce8.png"
              alt="HI QINGDAO"
            />
          </div>
        </a>

        <div class="ni-header__right">
          <div class="ni-header__top-row">
            <div class="ni-header__search-wrap">
              <form class="ni-header__search" @submit.prevent="handleSearchSubmit">
                <button
                  type="button"
                  class="ni-header__search-cat"
                  @click="showCategoryDropdown = !showCategoryDropdown"
                >
                  <span class="ni-header__search-cat-arrow">∨</span>
                  <span>{{ selectedCategory }}</span>
                </button>

                <div v-if="showCategoryDropdown" class="ni-header__dropdown-backdrop" @click="showCategoryDropdown = false"></div>
                <div v-if="showCategoryDropdown" class="ni-header__dropdown ni-animate-fade-in">
                  <button
                    v-for="cat in categoryOptions"
                    :key="cat"
                    type="button"
                    class="ni-header__dropdown-item"
                    @click="selectCategory(cat)"
                  >
                    {{ cat }}
                  </button>
                </div>

                <input
                  id="header-search-input"
                  v-model="searchQuery"
                  type="text"
                  class="ni-header__search-input"
                  :placeholder="lang === 'zh' ? '搜索新闻、活动、图集...' : 'Search portal documents...'"
                />
                <button id="search-submit" type="submit" class="ni-header__search-btn" aria-label="Search">
                  <svg class="ni-icon ni-icon--search" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <circle cx="11" cy="11" r="8" />
                    <path d="m21 21-4.35-4.35" />
                  </svg>
                </button>
              </form>
            </div>

            <button
              id="lang-toggle-btn"
              type="button"
              class="ni-header__lang"
              title="Switch Language"
              @click="toggleLang"
            >
              <span class="ni-header__lang-icon">
                <svg class="ni-icon ni-icon--globe ni-animate-spin-slow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M2 12h20" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
              </span>
              <span>{{ lang === 'zh' ? '中文简体' : 'English' }}</span>
            </button>
          </div>

          <div class="ni-header__nav-row">
            <nav class="ni-header__nav">
              <a
                v-for="item in navItems"
                :key="item.label"
                :href="item.href"
                class="ni-header__nav-link"
                :class="{ 'ni-header__nav-link--active': activeNav === item.href }"
                @click="handleNavClick(item.href, $event)"
              >
                <span>{{ item.label }}</span>
              </a>
            </nav>

            <div v-if="!isLoggedIn" class="ni-header__login-wrap">
              <button
                id="login-link"
                type="button"
                class="ni-header__login"
                @click="handleLogin"
              >
                <span class="ni-header__login-icon">
                  <svg class="ni-icon ni-icon--user" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </span>
                <span>{{ lang === 'zh' ? '登录' : 'Sign In' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile -->
      <div class="ni-header__mobile">
        <a href="#home" class="ni-header__logo-link">
          <img
            class="ni-header__logo-img ni-header__logo-img--mobile"
            src="https://www.qdpic.cn/obs/images/195e37770fe5a66e8c08e916b144cce8.png"
            alt="HI QINGDAO"
          />
        </a>

        <div class="ni-header__mobile-actions">
          <button
            id="mobile-lang-toggle"
            type="button"
            class="ni-header__mobile-btn ni-header__mobile-btn--lang"
            aria-label="Switch language"
            @click="toggleLang"
          >
            <svg class="ni-icon ni-icon--globe" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <circle cx="12" cy="12" r="10" />
              <path d="M2 12h20" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
          </button>
          <button
            id="mobile-menu-toggle"
            type="button"
            class="ni-header__mobile-btn ni-header__mobile-btn--menu"
            :aria-label="mobileMenuOpen ? 'Close menu' : 'Open menu'"
            @click="mobileMenuOpen = !mobileMenuOpen"
          >
            <svg v-if="mobileMenuOpen" class="ni-icon ni-icon--close" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
            <svg v-else class="ni-icon ni-icon--menu" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M4 6h16" />
              <path d="M4 12h16" />
              <path d="M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile drawer -->
    <Transition name="ni-header-drawer">
      <div v-if="mobileMenuOpen" class="ni-header__drawer ni-header__drawer--open">
        <form class="ni-header__drawer-search" @submit.prevent="handleSearchSubmit">
          <input
            id="mobile-search-input"
            v-model="searchQuery"
            type="text"
            class="ni-header__drawer-search-input"
            :placeholder="lang === 'zh' ? '搜时事、图文、VR特展...' : 'Search...'"
          />
          <button id="mobile-search-submit" type="submit" class="ni-header__drawer-search-btn" aria-label="Search">
            <svg class="ni-icon ni-icon--search" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
          </button>
        </form>

        <div class="ni-header__drawer-nav">
          <a
            v-for="item in navItems"
            :key="item.href + item.label"
            :href="item.href"
            class="ni-header__drawer-link"
            @click="closeMobileMenu(item.href)"
          >
            <span>{{ item.label }}</span>
            <span class="ni-header__drawer-link-arrow">→</span>
          </a>
        </div>

        <div class="ni-header__drawer-footer">
          <p class="ni-header__drawer-copy">
            {{ lang === 'zh' ? 'Qingdao 国际新闻中心 版权所有 · 2026' : 'Qingdao International PR Office · 2026' }}
          </p>
          <button
            v-if="!isLoggedIn"
            id="mobile-resident-login"
            type="button"
            class="ni-header__drawer-cta"
            @click="handleLogin"
          >
            {{ lang === 'zh' ? '登录' : 'Sign In' }}
          </button>
          <a
            v-else
            id="mobile-resident-login"
            href="#qd-service"
            class="ni-header__drawer-cta"
            @click="closeMobileMenu('#qd-service')"
          >
            {{ lang === 'zh' ? '在线政务市民中心' : 'Foreign Resident Hub' }}
          </a>
        </div>
      </div>
    </Transition>
  </header>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';

const props = defineProps({
  lang: {
    type: String,
    default: 'zh',
    validator: (value) => ['zh', 'en'].includes(value)
  },
  isLoggedIn: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['search', 'update:lang', 'login']);

const searchQuery = ref('');
const showCategoryDropdown = ref(false);
const selectedCategory = ref(props.lang === 'zh' ? '新闻' : 'News');
const mobileMenuOpen = ref(false);
const activeNav = ref('#home');

const navItemsZh = [
  { label: '首页', href: '#home' },
  { label: '城市新闻热榜', href: '#latest-news' },
  { label: '山海名城', href: '#qingdao-world' },
  { label: '国际传播', href: '#int-communication' },
  { label: '青岛图片库', href: '#photo-depot' },
  { label: '视觉青岛', href: '#visual-qingdao' },
  { label: '青岛发布', href: '#qd-service' },
  { label: '问青岛服务平台', href: '#qd-service' }
];

const navItemsEn = [
  { label: 'Home', href: '#home' },
  { label: 'Trending News', href: '#latest-news' },
  { label: 'Vibrant City', href: '#qingdao-world' },
  { label: 'Global Outreach', href: '#int-communication' },
  { label: 'Photo Gallery', href: '#photo-depot' },
  { label: 'Visual Qingdao', href: '#visual-qingdao' },
  { label: 'QD Release', href: '#qd-service' },
  { label: 'Services Hub', href: '#qd-service' }
];

const sectionIds = ['#home', '#latest-news', '#qingdao-world', '#int-communication', '#photo-depot', '#visual-qingdao', '#vr-hall', '#qd-service'];
let sectionObserver = null;

const categoryOptionsZh = ['新闻', '专栏', '图库', '视频', 'VR展馆'];
const categoryOptionsEn = ['News', 'Features', 'Photos', 'Videos', 'VR'];

const navItems = computed(() => (props.lang === 'zh' ? navItemsZh : navItemsEn));
const categoryOptions = computed(() => (props.lang === 'zh' ? categoryOptionsZh : categoryOptionsEn));

watch(
  () => props.lang,
  (lang) => {
    selectedCategory.value = lang === 'zh' ? '新闻' : 'News';
  }
);

function handleLogin() {
  mobileMenuOpen.value = false;
  emit('login');
}

function handleSearchSubmit() {
  emit('search', searchQuery.value);
}

function toggleLang() {
  emit('update:lang', props.lang === 'zh' ? 'en' : 'zh');
}

function selectCategory(cat) {
  selectedCategory.value = cat;
  showCategoryDropdown.value = false;
}

function setActiveNav(href) {
  activeNav.value = href;
}

function getScrollContainer() {
  return document.querySelector('.ni-page') || document.scrollingElement || document.documentElement;
}

function getHeaderOffset() {
  const header = document.querySelector('.ni-header');
  return header ? header.offsetHeight : 0;
}

function scrollToAnchor(href) {
  const container = getScrollContainer();

  if (href === '#home') {
    container.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  const id = href.replace('#', '');
  const el = document.getElementById(id);
  if (!el) return;

  const headerOffset = getHeaderOffset();
  const containerRect = container.getBoundingClientRect();
  const elTop = el.getBoundingClientRect().top - containerRect.top + container.scrollTop;

  container.scrollTo({
    top: Math.max(0, elTop - headerOffset),
    behavior: 'smooth',
  });
}

function handleNavClick(href, event) {
  event.preventDefault();
  setActiveNav(href);
  scrollToAnchor(href);
}

function closeMobileMenu(href) {
  mobileMenuOpen.value = false;
  handleNavClick(href, { preventDefault: () => {} });
}

onMounted(() => {
  const hrefToId = (href) => href.replace('#', '');
  const visibleSections = new Map();

  sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = `#${entry.target.id}`;
        if (entry.isIntersecting) {
          visibleSections.set(id, entry.intersectionRatio);
        } else {
          visibleSections.delete(id);
        }
      });

      if (visibleSections.size === 0) return;

      let bestId = '#home';
      let bestRatio = 0;
      visibleSections.forEach((ratio, id) => {
        if (ratio >= bestRatio) {
          bestRatio = ratio;
          bestId = id;
        }
      });
      activeNav.value = bestId;
    },
    { rootMargin: '-20% 0px -60% 0px', threshold: [0, 0.1, 0.25, 0.5] }
  );

  sectionIds.forEach((href) => {
    const el = document.getElementById(hrefToId(href));
    if (el) sectionObserver.observe(el);
  });
});

onBeforeUnmount(() => {
  if (sectionObserver) {
    sectionObserver.disconnect();
    sectionObserver = null;
  }
});
</script>
